import {
    IFinancialTableData,
    INotesMovementScheduleData,
    INotesTableData,
} from '../../../../aumico-lib-annualreport-fe/src/lib';

import { INotesSuperTableDataForPrintPreview } from './notes-super-table-data-for-print-preview.interface';

export interface INotesSubSectionPrintPreview {
    id?: number;
    title: string;
    components: INotesSubSectionPrintPreviewComponent[];
}

export interface INotesSubSectionPrintPreviewComponent {
    componentId?: string;
    componentType: string;
    data:
        | IFinancialTableData[]
        | string
        | INotesTableData[]
        | INotesMovementScheduleData[]
        | INotesSuperTableDataForPrintPreview;

    tables?: IFinancialTableData[][] | INotesMovementScheduleData[][];

    componentTitle?: string;

    /** FX (REV-21512): mirrors `IItem.isFxFormat` — the preview follows the print format. */
    isFxFormat?: boolean;
}
